export {
  type CliErrorCtx,
  defineWixConfig,
  type WixAstroConfig,
  type WixCliPlugin,
} from '@wix/cli-plugin-core';
